import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3d49dbd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yt-search__field" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-magnifying-glass",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = {
  class: "sr-only",
  for: "yt-header-search"
}
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "yt-search__divider",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "yt-search__submit-label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-magnifying-glass yt-search__submit-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = { class: "yt-panel" }
const _hoisted_10 = { class: "yt-panel__top" }
const _hoisted_11 = { class: "yt-panel__col" }
const _hoisted_12 = { class: "yt-panel__head" }
const _hoisted_13 = {
  key: 0,
  class: "yt-panel__recent"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-regular fa-clock",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = { class: "yt-panel__recent-q" }
const _hoisted_17 = {
  key: 0,
  class: "yt-panel__recent-count"
}
const _hoisted_18 = { class: "yt-panel__recent-actions" }
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-up-right-from-square" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "yt-panel__empty"
}
const _hoisted_26 = { class: "yt-panel__col" }
const _hoisted_27 = { class: "yt-panel__head" }
const _hoisted_28 = { class: "yt-panel__suggest" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "yt-panel__name" }
const _hoisted_31 = { class: "yt-panel__price" }
const _hoisted_32 = {
  key: 0,
  class: "yt-panel__empty"
}
const _hoisted_33 = { class: "yt-panel__keywords" }
const _hoisted_34 = { class: "yt-panel__tags" }
const _hoisted_35 = ["onClick"]

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { apiViewPost } from '@/api/index'
import { PRODUCTS_LIST_ALL } from '@/const/ApiRedis'
import Utils from '@/utils/Utils'
import router from '@/router'
import Location from './Location.vue'
import { SEARCH, productDetailPath } from '@/const/path'

const RECENT_KEY = 'home-search-recent'
const MAX_RECENT = 8

type RecentItem = { q: string; count?: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

const { t } = useI18n()

const keyword = ref('')
const selectedLocations = ref<string[]>([])
const panelOpen = ref(false)
const recentSearches = ref<RecentItem[]>([])
const suggested = ref<any[]>([])
const loadingSuggest = ref(false)
const rootRef = ref<HTMLElement | null>(null)
const locationRef = ref<{ close: () => void } | null>(null)

const popularKeywords = computed(() => [
  t('home.kwFinance'),
  t('home.kwBusiness'),
  t('home.kwIt'),
  t('home.kwAccountant'),
  t('home.kwMarketing'),
])

const loadRecent = () => {
  try {
    const raw = localStorage.getItem(RECENT_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    if (!Array.isArray(parsed)) {
      recentSearches.value = []
      return
    }
    recentSearches.value = parsed
      .map((x: any) =>
        typeof x === 'string'
          ? { q: x }
          : x?.q
            ? { q: String(x.q), count: x.count }
            : null,
      )
      .filter(Boolean) as RecentItem[]
  } catch {
    recentSearches.value = []
  }
}

const saveRecent = () => {
  localStorage.setItem(RECENT_KEY, JSON.stringify(recentSearches.value.slice(0, MAX_RECENT)))
}

const pushRecent = (q: string) => {
  const trimmed = q.trim()
  if (!trimmed) return
  recentSearches.value = [
    { q: trimmed },
    ...recentSearches.value.filter((r) => r.q.toLowerCase() !== trimmed.toLowerCase()),
  ].slice(0, MAX_RECENT)
  saveRecent()
}

const clearRecent = () => {
  recentSearches.value = []
  saveRecent()
}

const removeRecent = (idx: number) => {
  recentSearches.value.splice(idx, 1)
  saveRecent()
}

const formatPrice = (p: any) => {
  if (!p?.minPrice) return t('text.contact')
  return `${Utils.parseMoney(String(p.minPrice))} ${p.currency || 'VNĐ'}`
}

const loadSuggested = async () => {
  if (suggested.value.length) return
  loadingSuggest.value = true
  try {
    const res: any = await apiViewPost({
      apiCode: PRODUCTS_LIST_ALL,
      page: 1,
      size: 5,
      isDesc: false,
      header: false,
      isUser: true,
      wheres: [],
      orders: [{ field: 'productId', direction: 'DESC' }],
    })
    suggested.value = res?.data?.data?.body || []
  } catch {
    suggested.value = []
  } finally {
    loadingSuggest.value = false
  }
}

const closePanel = () => {
  panelOpen.value = false
}

const openPanel = () => {
  locationRef.value?.close()
  panelOpen.value = true
  loadSuggested()
}

const onDocClick = (e: MouseEvent) => {
  const el = rootRef.value
  if (!el || el.contains(e.target as Node)) return
  if (panelOpen.value) closePanel()
  locationRef.value?.close()
}

const goSearch = (q?: string) => {
  const term = (q ?? keyword.value).trim()
  if (term) {
    keyword.value = term
    pushRecent(term)
  }
  const query: Record<string, string> = {}
  if (term) query.q = term
  if (selectedLocations.value.length) {
    query.location = selectedLocations.value.join(',')
  }
  closePanel()
  locationRef.value?.close()
  router.push({ path: SEARCH, query })
}

const submitSearch = () => goSearch()
const applyRecent = (q: string) => goSearch(q)
const applyKeyword = (tag: string) => goSearch(tag)

const goProduct = (p: any) => {
  const id = p.productId ?? p.id
  closePanel()
  if (id != null) router.push({ path: productDetailPath(id) })
}

onMounted(() => {
  loadRecent()
  document.addEventListener('mousedown', onDocClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', onDocClick)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootRef",
    ref: rootRef,
    class: "header-search"
  }, [
    _createElementVNode("form", {
      class: "yt-search",
      onSubmit: _withModifiers(submitSearch, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('home.searchPlaceholder')), 1),
        _withDirectives(_createElementVNode("input", {
          id: "yt-header-search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          type: "search",
          class: "yt-search__input",
          placeholder: _ctx.$t('home.searchPlaceholder'),
          autocomplete: "off",
          onFocus: openPanel,
          onClick: openPanel
        }, null, 40, _hoisted_4), [
          [_vModelText, keyword.value]
        ])
      ]),
      _hoisted_5,
      _createVNode(Location, {
        ref_key: "locationRef",
        ref: locationRef,
        modelValue: selectedLocations.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedLocations).value = $event)),
        onOpened: closePanel
      }, null, 8, ["modelValue"]),
      _createElementVNode("button", {
        type: "submit",
        class: "yt-search__submit",
        title: _ctx.$t('home.searchCta')
      }, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('home.searchCta')), 1),
        _hoisted_8
      ], 8, _hoisted_6)
    ], 32),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.recentSearches')), 1),
            (recentSearches.value.length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "yt-panel__clear",
                  onClick: clearRecent
                }, _toDisplayString(_ctx.$t('home.clearAll')), 1))
              : _createCommentVNode("", true)
          ]),
          (recentSearches.value.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentSearches.value, (item, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${item.q}-${idx}`
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "yt-panel__recent-main",
                      onClick: ($event: any) => (applyRecent(item.q))
                    }, [
                      _hoisted_15,
                      _createElementVNode("span", _hoisted_16, _toDisplayString(item.q), 1),
                      (item.count != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, " (" + _toDisplayString(item.count) + " " + _toDisplayString(_ctx.$t('home.resultCount')) + ") ", 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_14),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "yt-panel__icon-btn",
                        title: _ctx.$t('home.fillSearch'),
                        onClick: ($event: any) => (keyword.value = item.q)
                      }, _hoisted_21, 8, _hoisted_19),
                      _createElementVNode("button", {
                        type: "button",
                        class: "yt-panel__icon-btn",
                        title: _ctx.$t('home.remove'),
                        onClick: ($event: any) => (removeRecent(idx))
                      }, _hoisted_24, 8, _hoisted_22)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t('home.noRecent')), 1))
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.youMayLike')), 1)
          ]),
          _createElementVNode("ul", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggested.value, (p) => {
              return (_openBlock(), _createElementBlock("li", {
                key: p.productId ?? p.id
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "yt-panel__suggest-item",
                  onClick: ($event: any) => (goProduct(p))
                }, [
                  _createElementVNode("span", {
                    class: "yt-panel__thumb",
                    style: _normalizeStyle({ backgroundImage: p.imageDetail ? `url(${p.imageDetail})` : undefined })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(p.productName), 1),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(formatPrice(p)), 1)
                ], 8, _hoisted_29)
              ]))
            }), 128))
          ]),
          (!suggested.value.length && !loadingSuggest.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.$t('home.noSuggest')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.popularKeywords')), 1),
        _createElementVNode("div", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popularKeywords.value, (tag) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tag,
              type: "button",
              class: "yt-panel__tag",
              onClick: ($event: any) => (applyKeyword(tag))
            }, _toDisplayString(tag), 9, _hoisted_35))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, panelOpen.value]
    ])
  ], 512))
}
}

})